<template>
  <div class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-input
              v-validate="'required|alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Content"
              label-placeholder="Content"
              name="consignmentTypeName"
              v-model="frm.consignmentTypeName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('consignmentTypeName')"
              ><span class="digitelex-form-error-message">{{
                errors.first("consignmentTypeName")
              }}</span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('consignmentTypeName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-input
              v-validate="'alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Content Short Name"
              label-placeholder="Content Short Name"
              name="consignmentTypeShortName"
              v-model="frm.consignmentTypeShortName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('consignmentTypeShortName')"
              ><span class="digitelex-form-error-message">{{
                errors.first("consignmentTypeShortName")
              }}</span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('consignmentTypeShortName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="flex flex-wrap justify-end">
          <vs-button
            :disabled="!validateForm"
            @click="saveConsignmentType"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <vs-button class="ml-4" type="border" color="warning"
            >Cancel</vs-button
          >
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
  },
  methods: {
    saveConsignmentType() {
      if (this.frm.consignmentTypeId) {
        //Update
        // alert("Updated");
        this.$http
          .put("common/consignmentType", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.frm.consignmentTypeId = 0;
        this.frm.isActive = true;
        this.$http
          .post("common/consignmentType", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  data() {
    return {
      frm: {
        consignmentTypeId: 0,
        consignmentTypeName: null,
        consignmentTypeShortName: null,
        isActive: true,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        this.frm = after;
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.frm.consignmentTypeName != "" &&
        this.frm.consignmentTypeName != null
      );
    },
  },
  beforeMount() {
    console.log(this.frmData);
  },
};
</script>
